import { render, staticRenderFns } from "./ServiceOpening.vue?vue&type=template&id=1a5402bd&scoped=true&"
import script from "./ServiceOpening.vue?vue&type=script&lang=ts&"
export * from "./ServiceOpening.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceOpening.vue?vue&type=style&index=0&id=1a5402bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5402bd",
  null
  
)

export default component.exports